import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {useSelector, useDispatch} from 'react-redux';
import {LinearGradient} from 'expo-linear-gradient';
import i18n from 'i18n-js';
import PassButton from '../../commons/passButton';
import scanpackStyles from '../../style/scanpack';
import globalStyles from '../../style/global';
import ScanField from './ScanField';
import ToteBanner from './ToteBanner';
import ActionRow from './ActionRow';
import SuggestedCard from './SuggestedCard';
import ProgressHint from './ProgressHint';
import useWidth from '../scanToCartScanning/useWidth';
import {passItem, redirectToProductDetail} from '../../actions/productFirstActions';
import {selectToteIdentifier} from '../../selectors/productFirstSelectors';

const SuggestedPanel = () => {
  const dispatch = useDispatch();
  const width = useWidth();
  const toteIdentifier = useSelector(selectToteIdentifier);
  const {order, suggestedItem, tote, stage, bannerState, orderComplete, completeMessage} =
    useSelector(state => ({
      order: state.productFirst.order,
      suggestedItem: state.productFirst.suggestedItem,
      tote: state.productFirst.tote,
      stage: state.productFirst.stage,
      bannerState: state.productFirst.bannerState,
      orderComplete: state.productFirst.orderComplete,
      completeMessage: state.productFirst.completeMessage
    }));

  const showBanner = orderComplete || stage === 'tote';
  const banner = orderComplete ? 'complete' : bannerState;

  return (
    <View style={styles.container}>
      {order && (
        <LinearGradient
          start={{x: 0, y: 1}}
          end={{x: 0, y: 0}}
          colors={['#000000', '#00000006', '#00000006', '#000000']}
          style={scanpackStyles.actionButtonsView}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            style={[scanpackStyles.nowScanningTextView, globalStyles.nextItemOrder]}>
            {i18n.t('productFirst.orderAssigned', {
              orderNumber: order.increment_id,
              toteIdentifier,
              toteName: tote?.name || ''
            })}
          </Text>
          <ActionRow />
        </LinearGradient>
      )}

      <LinearGradient
        start={{x: 0, y: 1}}
        end={{x: 0, y: 0}}
        colors={['#142130', '#304454']}
        style={scanpackStyles.scanBarcodeGradientDesktop}>
        <View style={styles.scanRow}>
          <View style={scanpackStyles.scanBarcodeContainer}>
            <LinearGradient
              start={{x: 0, y: 1}}
              end={{x: 0, y: 0}}
              colors={['#6384ff', '#1329ff', '#35096c']}
              style={scanpackStyles.scanBarcodeSubGradient}
            />
          </View>

          <View style={scanpackStyles.scanBarCodeInputContainer}>
            <ScanField />
          </View>

          {suggestedItem && !orderComplete && (
            <PassButton
              windowWidth={width}
              orderItem={suggestedItem}
              onPress={() => dispatch(passItem())}
            />
          )}
        </View>
      </LinearGradient>

      {showBanner && (
        <ToteBanner
          state={banner}
          toteIdentifier={toteIdentifier}
          toteName={tote?.name || ''}
          message={completeMessage}
        />
      )}

      {suggestedItem && !orderComplete && (
        <SuggestedCard
          item={suggestedItem}
          width={width}
          onItemPress={item =>
            dispatch(redirectToProductDetail(item.product_id))
          }
        />
      )}

      {order && stage === 'product' && !suggestedItem && !orderComplete && (
        <ProgressHint />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 4
  },
  scanRow: {
    flexDirection: 'row'
  }
});

export default SuggestedPanel;
